module.exports = __webpack_public_path__ + "static/media/overview-white.83c7a31a.svg";